// This file is automatically generated from Rails routes.
// DO NOT modify it manually.
// To regenerate, run: bin/rake gitlab:js:routes

// js-routes reads the trailing argument as a route parameter rather than an options
// hash when it carries `id`, `to_param` or `toParam`. Mirrors `looks_like_serialized_model`
// in `core.js`, which is where `extract_options` makes the same call.
const isOptionsObject = (value) =>
  Object.prototype.toString.call(value) === '[object Object]' &&
  ('_options' in value || !('id' in value || 'to_param' in value || 'toParam' in value));

// Mirror `::Current.data_context` and `::Current.organization_resolver&.from_organization_params&.path` in
// `Routing::OrganizationsHelper::MappedHelpers#scoped_path_for`.
const dataContextOrganizationPath = () => gon?.data_context_organization_path;
const requestOrganizationPath = () => gon?.organization_path;

// Strip `organizationPath` so js-routes does not turn it into a query parameter.
const withoutOrganizationPathOption = (args) => {
  const { organizationPath, ...routeOptions } = args[args.length - 1];

  return [...args.slice(0, -1), routeOptions];
};

// Mirrors `Routing::OrganizationsHelper::MappedHelpers#scoped_path_for`.
export const resolveOrganizationScope = (args) => {
  const options = args[args.length - 1];
  const hasOrganizationPathOption = isOptionsObject(options) && 'organizationPath' in options;
  const routeArgs = hasOrganizationPathOption ? withoutOrganizationPathOption(args) : args;
  const dataContextPath = dataContextOrganizationPath();

  if (dataContextPath) {
    return { organizationPath: dataContextPath, routeArgs };
  }

  // `null` opts out of organization scoping, `undefined` reads as "not specified"
  // so that an unresolved value does not silently drop the request's own scope.
  if (hasOrganizationPathOption && options.organizationPath !== undefined) {
    return { organizationPath: options.organizationPath, routeArgs };
  }

  return { organizationPath: requestOrganizationPath(), routeArgs };
};

// The private `namespaceProject` helpers expect separate `namespacePath`
// and `projectPath` arguments. Typically we only have `project.fullPath`
// available on the frontend. This util splits `project.fullPath` into
// separate arguments so they can be passed to the private `namespaceProject` helpers.
export const splitProjectFullPath = (projectFullPath) => {
  if (!projectFullPath) {
    throw new Error('Route missing required keys: projectFullPath');
  }

  if (typeof projectFullPath !== 'string') {
    throw new Error('projectFullPath must be a string');
  }

  const splitProjectFullPath = projectFullPath.split("/");
  const namespacePath = splitProjectFullPath.slice(0, -1).join("/");
  const projectPath = splitProjectFullPath[splitProjectFullPath.length - 1];

  return { namespacePath, projectPath };
};
